import firebase from 'firebase/app';
import 'firebase/firestore';

// Add your firebase configuration here
const firebaseConfig = {
  apiKey: 'AIzaSyAbYYj5QzdmbphkcW5T9qJ_oM_vq-6O_l0',
  authDomain: 'react-firestore-crud-54f01.firebaseapp.com',
  projectId: 'react-firestore-crud-54f01',
  storageBucket: 'react-firestore-crud-54f01.appspot.com',
  messagingSenderId: '1046407865723',
  appId: '1:1046407865723:web:1d3ba490717d7fddcec9de'
};

// Initialize Firebase
const firebaseInit = firebase.initializeApp(firebaseConfig);

const firestoreDB = firebaseInit.firestore();

export default firestoreDB;
